import {functions, db} from "@/firebase/init"

export default {
    data () {
      return {
          adminDtls: JSON.parse(localStorage.getItem('adminDtls')),
          userDtls: JSON.parse(localStorage.getItem('userDtls')),
      }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
        clientID() {
            return this.$store.getters.getCustomerID
        }
    },
    methods: {
        showToast(data, isCustom = false, type = 'success' ) {
            if (isCustom) {
                if (type === 'danger') {
                    return this.$toast.error(data.message, {...data});
                } return this.$toast.open(data);
            } else {
                return this.$toast.open({
                    message: data.message,
                    pauseOnHover: true,
                    duration: 8000,
                });
            }

        },
        async addLog(log) {
            console.log('Adding log')
            console.log(log)
            // if(process.env.NODE_ENV === 'production'){
            let email = '';
            let operatingUser = '';
            let customerUID = '';
            const isAdmin = (!!(this.user.userType === 'normal' && this.adminDtls) || this.user.userType === 'admin' || this.user.userType === 'manager')
            if (isAdmin) {
                if (log.uid) {
                    const userRef = await db.collection('users').doc(log.uid).get();
                    this.userDtls = userRef.data();
                }
                if (this.user.userType === 'normal') {
                    operatingUser = this.adminDtls.firstName + " " + this.adminDtls.lastName;
                } else {
                    operatingUser = this.user.firstName + " " + this.user.lastName;
                }
                if (this.userDtls) {
                    email = this.userDtls.email;
                    customerUID = this.userDtls.uid;
                }
            } else {
                operatingUser = this.user.firstName + " " + this.user.lastName;
                email = this.user.email;
                customerUID = this.user.uid;
            }
            let data = {
                email,
                customerUID: log.uid ? log.uid : customerUID,
                message: log.message,
                level: log.level,
                primaryPlan: (log.primaryPlan) ? log.primaryPlan : 'N/A',
                isAdmin,
                operatingUser
            };
            console.log(data);
            // const addLog = functions.httpsCallable(
            //     "addLog"
            // );
            // addLog(data)
            db.collection("logs").add({
                message: data.message,
                level: data.level,
                uid: data.customerUID,
                email: data.email,
                createdAt: new Date().toISOString(),
                isAdmin: data.isAdmin,
                operatingUser: data.operatingUser,
                primaryPlan: data.primaryPlan
            })
                .catch(err => {
                    console.log(err);
                });
            // }
        },
        async addRecentActivity(data){
         try{
             const {email, firstName, lastName, uid} = this.user;
             const admin = {email , name : `${firstName} ${lastName}`, uid: uid};
             await  db.collection('recentActivity').add({
                 ...data,
                   admin,
                 createdAt: new Date().toISOString(),
             })
         }
         catch(e){
         console.log(e, 'Could not be inserted into db')
         }
        },
        async addToAdminActiveTask(data){
        try{
            const {email, firstName , lastName, uid} = this.user;

            await db.collection('activeTasks').add({
                email,
                name : `${firstName} ${lastName}`,
                userUid: uid,
                taskId: data.taskId, // taskId?
                taskType: data.actionType,  // taskType?
                domain: data.customer.domain,
                ticketId: data.ticketId,
                ticketText: data.text === undefined ? null : data.text,
                ip: data.ip===undefined ? null : data.ip,
                hbDocId: data.hbDocId === undefined ? null : data.hbDocId,
                checkInTime: new Date().toISOString(),
                status: true,
                createdAt: new Date().toISOString(),
            })
        }
        catch(e){
            console.log(e, 'Could Not insert into Active Task')
        }
        },
        async removeAdminActiveTask(data){
            try{
                const querySnapshot = await db.collection('activeTasks').where('taskId', '==', data.taskId).get();
                const updatePromises = querySnapshot.docs.map(async (doc) => {
                    try {
                        await db.collection('activeTasks').doc(doc.id).delete();
                        console.log(`Document ${doc.id} successfully deleted.`);
                    } catch (error) {
                        console.error(`Error updating document ${doc.id}:`, error);
                    }
                });
                await Promise.all(updatePromises);
            }
            catch(e){
            console.log(e, 'error in updating deleting active tasks');
            }
        },
        domainAdjustment(value){
            // return value.length > 13 ? `${value.slice(0,13)}...` : value
            return value
        },
    }
}
